import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["picture", "email"];
/** @jsx jsx */
import React, { useState } from 'react';
import { jsx } from '@emotion/react';
import { defineMessages, useIntl } from 'react-intl-next';
import { UI_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { useCallbackWithAnalytics } from '@atlaskit/analytics-next';
import { Profile } from '@atlaskit/atlassian-navigation';
import UserAvatarCircleIcon from '@atlaskit/icon/glyph/user-avatar-circle';
import Popup from '@atlaskit/popup';
import { NAVIGATION_CHANNEL } from '../../analytics';
import { useImageState } from '../../hooks/use-image-state';
export var AccountMenuPopup = function AccountMenuPopup(_ref) {
  var testId = _ref.testId,
    picture = _ref.picture,
    email = _ref.email,
    content = _ref.content;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var close = useCallbackWithAnalytics(function () {
    return setIsOpen(false);
  }, {
    eventType: UI_EVENT_TYPE,
    action: 'closed',
    actionSubject: 'popup',
    actionSubjectId: 'accountMenu'
  }, NAVIGATION_CHANNEL);
  var open = useCallbackWithAnalytics(function () {
    return setIsOpen(true);
  }, {
    eventType: UI_EVENT_TYPE,
    action: 'opened',
    actionSubject: 'popup',
    actionSubjectId: 'accountMenu'
  }, NAVIGATION_CHANNEL);
  return jsx(Popup, {
    isOpen: isOpen,
    onClose: close,
    testId: testId,
    placement: "bottom",
    trigger: function trigger(triggerProps) {
      return jsx(AccountMenuTrigger, _extends({
        onClick: isOpen ? close : open,
        testId: testId && "".concat(testId, "--trigger"),
        picture: picture,
        email: email
      }, triggerProps));
    },
    content: content
  });
};
var AccountMenuTrigger = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var picture = _ref2.picture,
    email = _ref2.email,
    props = _objectWithoutProperties(_ref2, _excluded);
  var intl = useIntl();
  var state = useImageState(picture || '');
  var tooltip = intl.formatMessage(messages.triggerTooltip);
  return jsx(Profile, _extends({}, props, {
    ref: ref,
    tooltip: email || tooltip,
    icon: picture && state === 'loaded' ? jsx("img", {
      css: {
        borderRadius: '50%',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
      },
      src: picture,
      alt: tooltip
    }) : jsx(UserAvatarCircleIcon, {
      label: tooltip,
      size: "medium"
    })
  }));
});
var messages = defineMessages({
  triggerTooltip: {
    id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
    defaultMessage: 'Account',
    description: 'Tooltip and alt-text for the account menu item'
  }
});